import {Portal, Snackbar, useTheme} from 'react-native-paper';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {setToastText} from '../../../store/slices/ui';
import React from 'react';
import {Platform} from 'react-native';
export function ToastDialog() {
  const text = useAppSelector(state => state.ui.toastText);
  const icon = useAppSelector(state => state.ui.toastIcon);
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const visible = text !== undefined;
  return (
    <Portal>
      <Snackbar
        theme={theme}
        visible={visible}
        style={{bottom: Platform.OS === 'web' ? 50 : 100}}
        icon={icon || 'close'}
        collapsable={true}
        onIconPress={() => dispatch(setToastText(undefined))}
        onDismiss={() => dispatch(setToastText(undefined))}>
        {text}
      </Snackbar>
    </Portal>
  );
}
